//@ts-check

export { getConfig } from './Config';
export { featurePage, browsePage, publisherPage, detailsPage, managePage } from './launchConstants';
export {
  getProductNames,
  azSort,
  makeVersionString,
  getCorrectUrlSlug,
  getProductsList,
  SAP_CODE_TO_ICON_ID,
  formatBytes,
  validateEmail,
  makeCCSupportedProductObjectsArray,
  getPartnerBadgeFunctionMaker,
  formatCurrency,
  parseFromLocalStorage,
} from './general';
export {
  handleLicenseDialogueForLaunch,
  handleAppDetailsForLaunch,
  handleHomeForLaunch,
  handleProfileForLaunch,
  handleHeaderForLaunch,
  handleBrowseForLaunch,
  handleManageForLaunch,
  sendDataToLaunch,
  processSearchInfo,
  getDefaultManageSearchInfo,
} from './analytics';

export { addScript } from './addScript';
export { addCSS } from './addCSS';
export { getStaticData } from './getStaticData';
export { formatDate } from './formatDate';
export { copyText } from './copyText';
export { formatWebsite } from './formatWebsite';
export { informNewRelic } from './informNewRelic';
export { capitalizeFirstLetter } from './capitalizeFirstLetter';
export { ContainerContext } from './ContainerContext';

export const STORAGE_KEYS = {
  SP_ISV_STATE_TOKEN: 'sp-isv-state-token',
  SP_ISV_NONCE: 'sp-isv-nonce',
};
